module.exports = __webpack_public_path__ + "static/voiceovers_lt-deafc0c7775480116a97a4b04576b1ca.png";